module.exports = __webpack_public_path__ + "media/images/black_history_month/jessica_harris-ca8d6471b266cde2aade168c2005bf9a.png";